import React from 'react';
import '../../../assests/css/customer/Customize.css';

const Customize = () => {
  return (
    <div className="cstm-bespoke-final-wrapper">
      {/* Top Heading Section */}
      <div className="cstm-heading-section">
        <h1 className="cstm-main-heading">From Fabric to Fashion</h1>
      </div>

      {/* Cards Container */}
      <div className="cstm-cards-container">
        {/* Left Card - Fabric Selection */}
        <div className="cstm-card cstm-left-card">
          <div className="cstm-image-container">
            <img
              src="https://i.pinimg.com/1200x/12/99/78/129978a403cbd3c729b228d9dbe7a8df.jpg"
              alt="Premium Silk Fabric"
              className="cstm-card-img"
            />
            <div className="cstm-text-overlay">
              <div className="cstm-content">
                <h3 className="cstm-subtitle">Your Chosen Fabric</h3>
                <h2 className="cstm-title">UNSTITCHED FABRIC SELECTION</h2>
                <p className="cstm-desc">
                  Every beautiful design begins with the perfect fabric — the texture, color, and feel that inspire your unique style.
                </p>
              </div>
            </div>
            <div className="cstm-glare"></div>
          </div>
        </div>

        {/* Right Card - Bespoke Gown Creation */}
        <div className="cstm-card cstm-right-card">
          <div className="cstm-image-container">
            <img
              src="images/customize.png"
              alt="customized dress"
              className="cstm-card-img"
            />
            <div className="cstm-text-overlay">
              <div className="cstm-content">
                <h3 className="cstm-subtitle">YOUR CUSTOM CREATION</h3>
                <h2 className="cstm-title">the art of your imagination</h2>
                <p className="cstm-desc">
                  Watch your selected fabric transform into a stunning customized dress that reflects your personality and vision.
                </p>
              </div>
            </div>
            <div className="cstm-glare"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Customize;